import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uix/uix/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "how-to-get-access"
    }}>{`How to Get Access`}</h1>
    <p>{`To use UI Extensibility you will need what to extend and Adobe App Builder. You will also need developer and admin roles assigned to users within your organization.`}</p>
    <p>{`To add your own business cases implementation to Adobe Service through UI Extensibility your IMS organization needs:`}</p>
    <ol>
      <li parentName="ol">{`Access to Adobe Service that implemented UI Extensibility, e.g. `}<a parentName="li" {...{
          "href": "../../services/aem-cf-console-admin/"
        }}>{`Adobe Experience Manager Content Fragments Console`}</a>{`.`}</li>
      <li parentName="ol">{`Access to Adobe App Builder in `}<a parentName="li" {...{
          "href": "https://developer.adobe.com/developer-console/docs/guides/"
        }}>{`Adobe Developer Console`}</a>{`.`}</li>
    </ol>
    <p>{`In order to `}<a parentName="p" {...{
        "href": "../guides/development-flow/"
      }}>{`create UI extension`}</a>{` for their own IMS organization user should have a `}<strong parentName="p">{`developer`}</strong>{` role in the AEM or Adobe I/O Runtime product profiles at `}<a parentName="p" {...{
        "href": "https://adminconsole.adobe.com/"
      }}>{`Adobe Admin Console`}</a>{`.
Having such a developer or admin role for the user will also grant access to `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/console/"
      }}>{`Adobe Developer Console`}</a>{`.`}</p>
    <p>{`Pay attention that implementing and deploying UI Extension is not enough. To enable UI Extension for all IMS organization members it should be `}<a parentName="p" {...{
        "href": "../guides/publication/"
      }}>{`published`}</a>{` by the IMS organization `}<strong parentName="p">{`system admin`}</strong>{` at `}<a parentName="p" {...{
        "href": "https://exchange.adobe.com/"
      }}>{`Adobe Exchange`}</a>{`.`}</p>
    <h3 {...{
      "id": "access-aem-content-fragments-console"
    }}>{`Access AEM Content Fragments Console`}</h3>
    <p>{`AEM Content Fragments Console available for all users of AEM as a Cloud Service with latest version. You may access it by logging in into your authoring service and clicking on Content Fragments button.
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "39.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/1bfed8b78c7ef272f4bc5c056e13c3a0/5530d/aem-global-navigation.webp 320w", "/uix/docs/static/1bfed8b78c7ef272f4bc5c056e13c3a0/0c8fb/aem-global-navigation.webp 640w", "/uix/docs/static/1bfed8b78c7ef272f4bc5c056e13c3a0/94b1e/aem-global-navigation.webp 1280w", "/uix/docs/static/1bfed8b78c7ef272f4bc5c056e13c3a0/0b34d/aem-global-navigation.webp 1920w", "/uix/docs/static/1bfed8b78c7ef272f4bc5c056e13c3a0/d5269/aem-global-navigation.webp 2560w", "/uix/docs/static/1bfed8b78c7ef272f4bc5c056e13c3a0/ba45c/aem-global-navigation.webp 2836w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/1bfed8b78c7ef272f4bc5c056e13c3a0/dd4a7/aem-global-navigation.png 320w", "/uix/docs/static/1bfed8b78c7ef272f4bc5c056e13c3a0/0f09e/aem-global-navigation.png 640w", "/uix/docs/static/1bfed8b78c7ef272f4bc5c056e13c3a0/bbbf7/aem-global-navigation.png 1280w", "/uix/docs/static/1bfed8b78c7ef272f4bc5c056e13c3a0/ac7a9/aem-global-navigation.png 1920w", "/uix/docs/static/1bfed8b78c7ef272f4bc5c056e13c3a0/c7a69/aem-global-navigation.png 2560w", "/uix/docs/static/1bfed8b78c7ef272f4bc5c056e13c3a0/100fa/aem-global-navigation.png 2836w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/uix/docs/static/1bfed8b78c7ef272f4bc5c056e13c3a0/bbbf7/aem-global-navigation.png",
            "alt": "Invoke Content Fragments Console",
            "title": "Invoke Content Fragments Console",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span>{`.`}</p>
    <p>{`As during development of UI Extensions developer will need access to AEM API please ensure that permissions allows to do so at least for development environment.`}</p>
    <h3 {...{
      "id": "access-app-builder"
    }}>{`Access App Builder`}</h3>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`Extensibility is a core capability of Adobe products. After UI Extensibility stable release App Builder will be offered together with services which support UI Extensions and will not require any additional onboarding.`}</p>
    <p>{`To get access to `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/app-builder/"
      }}>{`App Builder`}</a>{` please contact your Adobe account manager or proceed to self-onboarding and request a `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/app-builder/trial/"
      }}>{`trial access`}</a>{`  for your IMS organization.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      